import { create } from 'zustand';

interface TicketCockpitState {
  isOpen: boolean;
  ticketId: number | null;
  
  open: (ticketId: number) => void;
  close: () => void;
}

export const useTicketCockpit = create<TicketCockpitState>()((set) => ({
  isOpen: false,
  ticketId: null,

  open: (ticketId: number) => {
    set({ isOpen: true, ticketId });
  },

  close: () => {
    set({ isOpen: false, ticketId: null });
  },
}));

